import { loadPageTraitOptions } from '../commonTraitsMethod/pageTraits';
export default async function (editor, opts = {}) {
  const { projectId, version } = opts;
  const c = opts;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const pfx = c.pfx;
  const classPfx = c.classPfx;
  const pageTraitOpts = await loadPageTraitOptions(projectId, version);
  domc.addType('page-search-form', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': 'Search Form',
          droppable: ':not(form)',
          draggable: ':not(form)',
          collectionName: '',
          isDrop: false,
          projectId: c.projectId,
          traits: [
            {
              type: 'select',
              options: [
                ...Object.entries(pageTraitOpts).map(([key, value]) => {
                  return {
                    id: `${value.id}`,
                    name: `${value.name}`,
                  };
                }),
              ],
              label: 'Page',
              name: 'action',
            },
            {
              type: 'class_select',
              options: [
                { value: ``, name: 'Default' },
                { value: `${classPfx}-theme001`, name: 'Theme 1' },
                { value: `${classPfx}-theme002`, name: 'Theme 2' },
                { value: `${classPfx}-theme003`, name: 'Theme 3' },
              ],
              label: 'Theme',
            },
            {
              type: 'class_select',
              options: [
                { value: `form-inline`, name: 'Horizontal' },
                { value: ``, name: 'Vertical' },
              ],
              label: 'Display Type',
            },
          ].concat(defaultModel.prototype.defaults.traits),
        },
        updated(property, value, prevValue) {
          console.log(
            'Local hook: model.updated',
            'property',
            property,
            'value',
            value,
            'prevValue',
            prevValue,
          );
        },
        init() {
          console.log('this.isDrop()::', this.get('isDrop'));
          console.log('this.isDrop() THIS::', this.getClasses());
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'page-search-form') {
            return {
              type: 'page-search-form',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {},
    }),
  });
}
